module.exports = __webpack_public_path__ + "img/11-02_Managing Time.73c3bd47.svg";